import { Description } from "@mui/icons-material";
import axios from "axios";
import { getRandomUUID } from "../../Token";
import { getDeployConfigEndPoint, subscribeCameraCVApplicationEndPoint } from "../../configuration";

export const getUISchemaForConfig = (
  configData,
  formParameter,
  propertyKey
) => {
  /**
   * Todo: below logic may be updated after we get more clarity on the data structure
   */
var tempData = [];
formParameter.forEach(element => {
  if(element.key != undefined){
  tempData.push(element);
  }else{
    element?.items.forEach(e => {
      tempData.push(e);
    });
  }
});

  const templateData =
    configData?.configtemplate?.schema?.properties[propertyKey]?.properties;
  const finalSchemaData = {
    scemaTemplateData: templateData,
    scemaResourceData: [...tempData]?.map((item) => {
      if((Object.keys(item).indexOf("key")) > -1){
      const keyNameList = item?.key?.split(".");
      const elementType = item?.type
        ? item?.type
        : keyNameList[keyNameList?.length - 1] === "appearancerecognition"
        ? "checkboxes"
        : "text";
      const keyName =
        keyNameList[keyNameList?.length - 1] === "priority"
          ? "severity"
          : keyNameList[keyNameList?.length - 1];
      // Don't delete item.type - create a new object without it 
      const { type, ...itemWithoutType } = item;
      return {
        ...itemWithoutType,
        key: keyName,
        elementType: elementType,
        additionalInfo:
          keyNameList[keyNameList?.length - 1] === "appearancerecognition"
            ? "Collect additional data on gender and clothing color."
            : "",
      };
    
    }
    }),
  };
  return {
    ...finalSchemaData,
  };
};

export const submitAdvancedConfiguration = async (
  payload,
  activeSession,
  ids,
  setIsOpen
) => {
  setIsOpen(false);
};
